import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export function policyNav(element: HTMLElement): void {
  const links = element.querySelectorAll('a')
  let mm = gsap.matchMedia()

  const removeActiveFromAllLinks = () => {
    links.forEach(link => {
      link.classList.remove('active')
      link.parentElement?.classList.remove('active')
    })
  }

  mm.add('(min-width: 769px)', () => {
    links.forEach(link => {
      const urlObj = new URL(link.href)
      const matchedSection = document.querySelector(`#${urlObj.hash.substring(1)}`)

      gsap.to(matchedSection, {
        scrollTrigger: {
          trigger: matchedSection,
          start: 'top top+=200',
          end: 'bottom center',
          onEnter: () => {
            removeActiveFromAllLinks()
            link.classList.add('active')
          },
          onEnterBack: () => {
            removeActiveFromAllLinks()
            link.classList.add('active')
          }
        }
      })
    })
  })

  mm.add('(max-width: 768px)', () => {
    const qualificationsSection = document.querySelector('#qualifications')
    const contactSection = document.querySelector('.contact-info')

    gsap.to(element, {
      opacity: 1,
      duration: 0.15,
      scrollTrigger: {
        trigger: qualificationsSection,
        endTrigger: contactSection,
        end: 'top bottom',
        start: 'top-=150 top',
        toggleActions: 'play reverse play reverse'
      }
    })

    element.addEventListener('click', e => {
      element.classList.toggle('active')
    })

    links.forEach(link => {
      link.addEventListener('click', e => {
        removeActiveFromAllLinks()
        link.classList.add('active')
        link.parentElement?.classList.add('active')
      })
    })
  })
}
